import React from 'react';
import { theme, Typography, Space } from 'antd';

const { Title } = Typography;

interface GovardEntityHeaderProps {
  title: string;
  badge?: React.ReactNode;
  breadcrumbs?: React.ReactNode;
  actions?: React.ReactNode;
}

/**
 * GovardEntityHeader enforces the typography and layout rules for the top
 * of any Entity Workspace (Deal Hub, Contact Hub, etc).
 */
export function GovardEntityHeader({
  title,
  badge,
  breadcrumbs,
  actions,
}: GovardEntityHeaderProps) {
  const { token } = theme.useToken();

  return (
    <div
      style={{
        padding: `${token.paddingLG}px ${token.paddingLG}px ${token.paddingSM}px`,
        borderBottom: `1px solid ${token.colorBorderSecondary}`,
        display: 'flex',
        flexDirection: 'column',
        gap: token.marginXS, // 8px
      }}
    >
      {/* Breadcrumbs Top Row */}
      {breadcrumbs && (
        <div style={{ marginBottom: token.marginXXS }}>{breadcrumbs}</div>
      )}

      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          gap: token.marginMD,
        }}
      >
        <Space align="center" size="middle">
          <Title level={4} style={{ margin: 0, color: token.colorText }}>
            {title}
          </Title>
          {badge && <div>{badge}</div>}
        </Space>

        {/* Actions (Buttons) Right side */}
        {actions && (
          <Space size="small">
            {actions}
          </Space>
        )}
      </div>
    </div>
  );
}
